import { UPLOAD_FILE } from '@client/collections/File/schemas/uploadFile'
import { gqlApiInstance } from '@client/init'

export function useFileAction() {
  async function uploadFile(file: File | Blob): Promise<string> {
    const {
      UploadBookCover: { filePath },
    } = await gqlApiInstance.request(UPLOAD_FILE, {
      file,
    })

    return filePath
  }

  return {
    uploadFile,
  }
}
